"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var _default = {
  XSmall: 0.8,
  Small: 1,
  Medium: 1.25,
  Large: 1.5,
  S10: 1.6,
  S12: 1.5,
  S14: 1.4285714286,
  S16: 1.375,
  S18: 1.333,
  S24: 1.333,
  S32: 1.25,
  S40: 1.2
};
exports.default = _default;